module.exports = __webpack_public_path__ + "img/standort_pfarrei-st-martin_8.b2fea2d6.jpeg";